module.exports = __webpack_public_path__ + "static/media/04.43ec4710.png";